export const groupBy = (list, keyGetter) => {
    const result = new Map();
    for (const item of list) {
        const key = keyGetter(item);
        const group = result.get(key) || [];
        result.set(key, [...group, item]);
    }
    return result;
};
//# sourceMappingURL=groupBy.js.map